
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604124319609",
    "class": "icon",
    "viewBox": "0 0 1170 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "6222",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M603.794 6.89L302.011 204.373H151.485A152.208 152.208 0 0 0 0.01 358.043v307.562a151.989 151.989 0 0 0 151.476 153.598h150.526l301.783 197.483c42.642 18.87 75.702-1.317 75.702-43.885V51.214c0.073-43.08-33.864-62.683-75.702-44.324zM858.109 254.987a37.156 37.156 0 0 0-53.32-1.829 38.985 38.985 0 0 0-1.83 54.345 224.911 224.911 0 0 1 31.378 50.395 351.08 351.08 0 0 1 33.938 154.036 351.08 351.08 0 0 1-33.864 154.11 224.984 224.984 0 0 1-31.378 50.395 38.911 38.911 0 0 0 1.828 54.344 37.23 37.23 0 0 0 53.394-1.828 293.006 293.006 0 0 0 43.885-68.973 429.05 429.05 0 0 0 41.618-188.048 428.977 428.977 0 0 0-41.252-188.12 295.2 295.2 0 0 0-43.885-68.827z",
        "p-id": "6223"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1089.675 207.372a469.79 469.79 0 0 0-82.942-108.69 37.23 37.23 0 0 0-53.32 3.22 38.911 38.911 0 0 0 3.144 54.27 254.46 254.46 0 0 1 20.188 21.943 472.057 472.057 0 0 1 47.98 68.607 523.257 523.257 0 0 1 70.217 265.505 523.037 523.037 0 0 1-70.655 265.285 477.982 477.982 0 0 1-47.981 68.607 254.168 254.168 0 0 1-20.187 21.943 39.058 39.058 0 0 0-3.072 54.27 37.302 37.302 0 0 0 53.32 3.146 468.108 468.108 0 0 0 83.235-108.835 600.567 600.567 0 0 0 80.968-304.709 599.763 599.763 0 0 0-80.895-304.562z",
        "p-id": "6224"
      }
    }
  ]
})
    }
  